module.exports = __webpack_public_path__ + "img/P23-zh.a1fcf978.png";